export default "__VITE_ASSET__BOtY_Y$L__";